import React from "react";
import { InstagramLogo, Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#050505] border-t border-white/5">
      <div className="container-pd py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src="/logo.png"
              alt="Velocity Cleaning and Maintenance"
              className="h-28 w-auto"
            />
            <p className="text-zinc-400 mt-5 max-w-md leading-relaxed text-sm">
              Premium mobile car detailing across Perth, WA — interior refresh,
              paint correction, ceramic coatings, and full presentation packages
              delivered to your driveway.
            </p>
            <div className="flex items-center gap-3 mt-7">
              <SocialLink icon={<InstagramLogo size={18} weight="bold" />} href="https://www.instagram.com/velocity_cardetailing_/" label="Instagram" testid="social-instagram" />
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow">Packages</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#services" className="text-zinc-300 hover:text-white">Interior Detailing</a></li>
              <li><a href="#services" className="text-zinc-300 hover:text-white">Exterior Detailing</a></li>
              <li><a href="#services" className="text-zinc-300 hover:text-white">Complete Detail</a></li>
              <li><a href="#services" className="text-zinc-300 hover:text-white">Paint Correction</a></li>
              <li><a href="#services" className="text-zinc-300 hover:text-white">Ceramic Coatings</a></li>
              <li><a href="#travel" className="text-zinc-300 hover:text-white">Travel &amp; Coverage</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow">Contact</div>
            <ul className="mt-5 space-y-3 text-sm text-zinc-300">
              <li className="flex items-start gap-3"><Phone size={14} weight="bold" className="text-[#D4AF37] mt-1 shrink-0" /> <a href="tel:+61423004480" className="hover:text-white">0423 004 480</a></li>
              <li className="flex items-start gap-3"><EnvelopeSimple size={14} weight="bold" className="text-[#D4AF37] mt-1 shrink-0" /> <a href="mailto:admin@velocitymaintenance.net" className="hover:text-white">admin@velocitymaintenance.net</a></li>
              <li className="flex items-start gap-3"><MapPin size={14} weight="bold" className="text-[#D4AF37] mt-1 shrink-0" /> Piara Waters, WA</li>
            </ul>
            <a href="#quote" data-testid="footer-quote-btn" className="btn-primary mt-7 !py-3 !px-5 text-xs">Get a Quote</a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Velocity Cleaning &amp; Maintenance. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-zinc-300">Privacy</a>
            <a href="#" className="hover:text-zinc-300">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function SocialLink({ icon, href, label, testid }) {
  return (
    <a
      href={href}
      aria-label={label}
      data-testid={testid}
      className="w-10 h-10 flex items-center justify-center bg-[#0c0c0c] border border-white/5 text-zinc-300 hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-colors"
    >
      {icon}
    </a>
  );
}
